module.exports = __webpack_public_path__ + "fonts/kacho-hugetsu.a0743b20.ttf";